module.exports = __webpack_public_path__ + "img/icon-otp.c91ecfea.svg";